import React from 'react';
import { Typography, Box } from 'vindi-ds-components';
import { VdCheckmarkCircle2 } from 'vindi-ds-icons/vd';
import OnboardSection from './onboard_section';
import SecondStageSection from './second_stage_section';

function BaseHome({ isCompleted, cards }) {
  return (
    <>
      {isCompleted && (
        <>
          <SecondStageSection />
          <Box display='flex' gridGap='5px' alignItems='center' marginLeft='16px'>
            <VdCheckmarkCircle2 size='24px' color='green' />
            <Typography variant='subtitle1'>
              Configurações iniciais concluídas
            </Typography>
          </Box>
        </>
      )}
      <OnboardSection cards={cards} isCompleted={isCompleted} />
    </>
  );
}

export default BaseHome;
